import { CAS_JS_USER_KEY } from '@space-shell/common/services/auth'
import { apiCommunity, apiSparkle, apiSparkleSecurity } from '@space-shell/config/request'
import api from '@space-shell/config/request/api'
import apiHotmartTutor from '@space-shell/config/request/apiHotmartTutor'
import { ONE_SECOND_IN_MILLISECONDS } from '@space-shell/constant/time'
import {
  CREATE_PROFILE_STORAGE_KEY,
  MEMBERSHIP_STORE_KEY,
  VIEW_AS_STORE_KEY,
  useAuthStore,
  useViewAsStore
} from '@space-shell/core/store'

import type { AxiosRequestConfig } from 'axios'

import { TRACE_ID_STORAGE_KEY } from '../monitoring'

class AuthUtils {
  static get casUser() {
    return useAuthStore.getState()
  }

  static get token() {
    return this.casUser?.token
  }

  static isExpiredToken() {
    if (!this.token) {
      return false
    }

    const expiresAt = this.casUser?.expires_at

    return Boolean(expiresAt && new Date(expiresAt * ONE_SECOND_IN_MILLISECONDS) <= new Date())
  }

  static addTokenToRequest = (request: AxiosRequestConfig): AxiosRequestConfig => {
    const { headers = {}, params = {} } = request
    const isViewAsEnabled = useViewAsStore.getState()?.isEnabled
    const token = this.token

    const updatedHeaders = { ...headers }
    const updatedParams = { ...params }

    if (token) {
      updatedHeaders.Authorization = `Bearer ${token}`
    } else {
      ;['Authorization', 'X-View-As-Role'].forEach((key) => delete updatedHeaders[key])
      delete updatedParams?.roleType
    }

    if (!isViewAsEnabled) {
      delete updatedHeaders?.['X-View-As-Role']
      delete updatedParams?.roleType
    }

    return { ...request, headers: updatedHeaders, params: updatedParams }
  }

  private static _removeTokenFromRequest = () => {
    delete api.defaults.headers.common.Authorization
    delete apiSparkle.defaults.headers.common.Authorization
    delete apiCommunity.defaults.headers.common.Authorization
    delete apiSparkleSecurity.defaults.headers.common.Authorization
    delete apiHotmartTutor.defaults.headers.common.Authorization
  }

  private static _clearStorage = () => {
    useViewAsStore.setState({ isEnabled: false })
    useAuthStore.setState({})
    localStorage.removeItem(CAS_JS_USER_KEY)
    localStorage.removeItem(TRACE_ID_STORAGE_KEY)
    localStorage.removeItem(MEMBERSHIP_STORE_KEY)
    localStorage.removeItem(VIEW_AS_STORE_KEY)
    sessionStorage.setItem(CREATE_PROFILE_STORAGE_KEY, 'false')
  }

  static reset = () => {
    this._removeTokenFromRequest()
    this._clearStorage()
  }
}

export default AuthUtils
